import { Box, ButtonBase, ImageList, ImageListItem } from '@mui/material';
import { useMemo, useState } from 'react';
import useIsVisibleWithDismountState from '../../../../../../../../../../../../../../hooks/useIsVisibleWithDismountState';
import { MediaType } from '../../../../../../../../../../../../../../types/general.types';
import MediaInFullscreenWithZoom, {
  MediaFromMediaInFullScreenWithZoom,
} from '../../../../../../../../../../../../../media/MediaInFullscreenWithZoom/MediaInFullscreenWithZoom';
import { ImageOrVideoType } from '../../../../../../../../../../../../contexts/chatSocket/hooks/useChatWebsocket/useChatWebsocket.types';
import { isImageOrVideoMessageType } from '../../../../../../../../../../../../contexts/chatSocket/reducer/chatSocketReducer.utils';
import { CHAT_WIDTH } from '../../../../../../../../../../../../utils/chat.constants';
import VideoPreview from './components/VideoPreview/VideoPreview';
import { useImageOrVideoMessageStyles } from './imageOrVideoMessage.styles';
import { ImageOrVideoMessageProps } from './imageOrVideoMessage.types';

const MAX_WIDTH = CHAT_WIDTH - 60;
const MAX_WIDTH_PER_ITEM = MAX_WIDTH / 3;

const ImageOrVideoTypeMap = {
  [ImageOrVideoType.IMAGE]: MediaType.IMAGE,
  [ImageOrVideoType.VIDEO]: MediaType.VIDEO,
};

const ImageOrVideoMessage = ({ message, isMessageOfUser }: ImageOrVideoMessageProps) => {
  const { classes: styles } = useImageOrVideoMessageStyles();

  const { close, isMounted, isVisible, open } = useIsVisibleWithDismountState();

  const [selectedMedia, setSelectedMedia] = useState<
    MediaFromMediaInFullScreenWithZoom | undefined
  >(undefined);

  const handleSelectMedia = (media: MediaFromMediaInFullScreenWithZoom) => {
    setSelectedMedia(media);
    open();
  };

  const medias: MediaFromMediaInFullScreenWithZoom[] = useMemo<
    MediaFromMediaInFullScreenWithZoom[]
  >(
    () =>
      isImageOrVideoMessageType(message)
        ? message.data.urlNameAndTypes.map((urlNameAndType) => ({
            url: urlNameAndType.url,
            type: ImageOrVideoTypeMap[urlNameAndType.type],
          }))
        : [],
    [message.data],
  );

  if (!isImageOrVideoMessageType(message)) {
    return null;
  }

  const width = medias.length > 2 ? undefined : MAX_WIDTH_PER_ITEM * medias.length;
  const cols = medias.length > 2 ? 3 : medias.length;

  return (
    <Box
      sx={{
        width: width,
      }}
    >
      <ImageList
        cols={cols}
        rowHeight={94}
        style={{
          flexDirection: isMessageOfUser ? 'row-reverse' : 'row',
        }}
      >
        {medias.map((media) => (
          <ImageListItem key={media.url}>
            <ButtonBase className={styles.button} onClick={() => handleSelectMedia(media)}>
              {media.type === MediaType.IMAGE ? (
                <img className={styles.image} src={media.url} loading="lazy" />
              ) : (
                <VideoPreview url={media.url} />
              )}
            </ButtonBase>
          </ImageListItem>
        ))}
      </ImageList>
      {isMounted && (
        <MediaInFullscreenWithZoom
          onClose={close}
          medias={medias}
          isOpen={isVisible}
          selectedMedia={selectedMedia}
        />
      )}
    </Box>
  );
};

export default ImageOrVideoMessage;
